module.exports = __webpack_public_path__ + "img/onboarding-step-5.0d6511fa.png";